sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Dispo = BlockBase.extend("com.reply.leaviosa.blocks.dispo.Dispo", {
	});

	return Dispo;
});